import React from "react";
import { Box, Typography, Card, CardContent, Stack, Grid } from "@mui/material";
import "./SingleChadavaPackageItem.scss";

interface SingleChadavaPackageItemProps {
  packageImage: any;
  packageName: any;
  templeName?: any;
  templeAddress: any;
}

const SingleChadavaPackageItem: React.FC<SingleChadavaPackageItemProps> = ({
  packageImage,
  packageName,
  templeName,
  templeAddress,
}) => {
  return (
    <Card className="productCard">
      <Grid container spacing={1} alignItems="center">
        <Grid item xs={4}>
          <Box className="productImage">
            <img
              src={typeof packageImage === "string" ? packageImage : ""}
              alt={packageName || "package"}
              loading="lazy"
            />{" "}
          </Box>
        </Grid>

        <Grid item xs={8}>
          <CardContent className="productContentWrapper">
            <Stack direction="row" alignItems="center">
              <Typography className="productDescription truncate">
                {packageName}
              </Typography>
            </Stack>
            <Stack direction="row" alignItems="center" mb={1}>
              <Typography className="productDescription templeName">
                {templeName}, {templeAddress}
              </Typography>
            </Stack>
          </CardContent>
        </Grid>
      </Grid>
    </Card>
  );
};

export default SingleChadavaPackageItem;
